
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report-issue",
      function () {
        return require("private-next-pages/report-issue/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report-issue"])
      });
    }
  